import { logUsage } from 'owa-analytics';
import { CloudFile } from 'owa-attachment-file-types';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import {
    createSharingLinkFromFileProvider,
    CreateSharingLinkFromFileProviderResult,
} from 'owa-fileprovider-link-services';
import { getGuid } from 'owa-guid';
import { LinkIdContainer } from 'owa-attachment-link-common';
import { preloadLinkData, RecipientContainer } from 'owa-link-data';
import {
    addInsertLinkViewState,
    onSharingLinkRetrivalFailure,
    removeInsertLinkViewState,
} from '../actions/internalActions';
import { createLinkPlaceholder } from '../components/LinkPlaceholder';
import { OWA_INSERT_LINK_PLACEHOLDER } from '../utils/constants';
import { replacePlaceholderWithBeautifulLink } from './replacePlaceholderWithBeautifulLink';

export async function insertLinkIntoComposeEditor(
    viewState: EditorViewState,
    getRecipientWells: () => RecipientContainer[],
    fromAddress: string,
    linkIdContainer: LinkIdContainer,
    file: CloudFile,
    placeholderId: string,
    viaContextMenuItem: boolean
) {
    let createLinkResult: CreateSharingLinkFromFileProviderResult;
    try {
        createLinkResult = await createSharingLinkFromFileProvider(
            file.providerType,
            file.fileId,
            file.location,
            file.isFolder,
            file.providerEndpointUrl
        );
    } catch (e) {
        logUsage('InsertLinksIntoComposeDone', {
            success: false,
            viaContextMenuItem: viaContextMenuItem,
            providerType: file.providerType,
        });
        onSharingLinkRetrivalFailure(placeholderId);
        return;
    }

    logUsage('InsertLinksIntoComposeDone', {
        success: true,
        viaContextMenuItem: viaContextMenuItem,
        providerType: file.providerType,
    });
    replacePlaceholderWithBeautifulLink(
        createLinkResult,
        file,
        placeholderId,
        viewState,
        getRecipientWells,
        fromAddress,
        linkIdContainer
    );

    removeInsertLinkViewState(placeholderId);
}

export async function insertLinksIntoComposeEditor(
    viewState: EditorViewState,
    files: CloudFile[],
    linkIdContainer: LinkIdContainer,
    getRecipientWells: () => RecipientContainer[],
    fromAddress: string
) {
    if (files.length === 0) {
        return;
    }

    // Insert link placeholders
    const placeholderIds: string[] = [];
    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const placeholderId = OWA_INSERT_LINK_PLACEHOLDER + getGuid();
        placeholderIds.push(placeholderId);
        addInsertLinkViewState(placeholderId, file);

        logUsage('InsertLinksIntoComposeStart', { providerType: file.providerType });
        createLinkPlaceholder(
            viewState,
            placeholderId,
            file,
            getRecipientWells,
            linkIdContainer,
            fromAddress,
            null
        );
    }

    await preloadLinkData.import();

    // Retrieve the sharing link to replace the placeholder with beautiful link
    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        await insertLinkIntoComposeEditor(
            viewState,
            getRecipientWells,
            fromAddress,
            linkIdContainer,
            file,
            placeholderIds[i],
            false /* viaContextMenuItem */
        );
    }
}
